import { render, staticRenderFns } from "./SectionTag.vue?vue&type=template&id=0d7ef1d6&scoped=true&lang=pug&"
import script from "./SectionTag.vue?vue&type=script&lang=js&"
export * from "./SectionTag.vue?vue&type=script&lang=js&"
import style0 from "./SectionTag.vue?vue&type=style&index=0&id=0d7ef1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ef1d6",
  null
  
)

export default component.exports